<div style="max-width: 90vw">
  <div mat-dialog-title>
    <h5>Approve Change Order</h5>
  </div>
  <p *ngIf="!isMobile">Modify Job with Change Order</p>

  <div mat-dialog-content>
    <form #upgradeForm="ngForm" (ngSubmit)="approveChangeOrder(upgradeForm)">
      <div *ngIf="upgradeAreaSummaries.length==0" class="col-12">
        <h6>No upgrades or options available.</h6>
      </div>

      <div *ngIf="isMobile" class="mobile">
        <div class="text-bidit-primary" *ngFor="let area of upgradeAreaSummaries">
          <h5>{{area.area_Name}}</h5>

          <div *ngFor="let lineItem of area.quoteAreas">
            <div *ngIf="lineItem.changeOrderItem" class="card border-bidit-dark">
              <div class="card-body">
                <div *ngIf="lineItem.changeOrderItem.changeOrderItem_Name" class="text-bidit-primary-header " id="mobile_changeOrderItem_Name">{{lineItem.changeOrderItem.changeOrderItem_Name}}</div>
                <div *ngIf="!lineItem.changeOrderItem.changeOrderItem_Name" class="text-bidit-primary-header " id="mobile_changeOrderItem_subArea_Name">{{lineItem.quoteItem.subArea.subArea_Name}}</div>
                <div class="col">
                  <span *ngIf="lineItem.changeOrderItem.item.item_Part">Product: {{lineItem.changeOrderItem.item.item_Part}}, </span>
                  {{lineItem.changeOrderItem.item.item_Name}}
                  <div class="mt-2">
                    <div *ngIf="lineItem.changeOrderItem.rValue" class="col">
                      <label class="mr-2">R-Value: </label>
                      <span>
                        {{lineItem.changeOrderItem.rValue.rValue_Desc}}
                      </span>
                    </div>
                    <div>
                      <label>Sqr Ftg: </label>
                      <span>{{lineItem.changeOrderItem.area_SqrFtgAdjustment}}</span>
                    </div>
                  </div>
                  <mat-radio-group name="changeOrderItem_RadioValue{{lineItem.changeOrderItem.changeOrderItem_ID}}"
                                   [(ngModel)]="lineItem.changeOrderItem.changeOrderItem_RadioValue" #changeOrderItem_RadioValue="ngModel"
                                   (change)="calculateConversion()">
                    <mat-radio-button [value]="1">Accept</mat-radio-button>
                    <!--<mat-radio-button [value]="0">Decline</mat-radio-button>-->
                  </mat-radio-group>
                  <span class="float-right"><strong>Cost Change: </strong>${{lineItem.changeOrderItem.changeOrderItem_TotalCost | number: '1.2-2'}}</span>
                </div>
              </div>
            </div>
          </div>
          <div *ngFor="let newItem of area.newItems">
            <div class="card border-bidit-dark">
              <div class="card-body">
                <div *ngIf="newItem.changeOrderItem_Name" class="text-bidit-primary-header">{{newItem.changeOrderItem_Name}}</div>
                <div *ngIf="!newItem.area_Name" class="text-bidit-primary-header">{{newItem.subArea.subArea_Name}}</div>
                <div class="col">
                  <span *ngIf="newItem.item.item_Part">Product: {{newItem.item.item_Part}}, </span>
                  {{newItem.item.item_Name}}
                  <div class="mt-2">
                    <div *ngIf="newItem.item.rValue" class="col">
                      <label class="mr-2">R-Value: </label>
                      <span>
                        {{newItem.item.rValue.rValue_Desc}}
                      </span>
                    </div>
                    <div>
                      <label>Sqr Ftg: </label>
                      <span>{{newItem.changeOrderItem_SqrFtgAdjustment}}</span>
                    </div>
                  </div>
                  <mat-radio-group name="changeOrderItem_RadioValue{{newItem.changeOrderItem_ID}}"
                                   [(ngModel)]="newItem.changeOrderItem_RadioValue" #changeOrderItem_RadioValue="ngModel"
                                   (change)="calculateConversion()">
                    <mat-radio-button [value]="1">Accept</mat-radio-button>
                    <!--<mat-radio-button [value]="0">Decline</mat-radio-button>-->
                  </mat-radio-group>
                  <span class="float-right"><strong>Cost Change: </strong>${{newItem.changeOrderItem_TotalCost | number: '1.2-2'}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div *ngIf="!isMobile">
        <div *ngFor="let area of upgradeAreaSummaries">
          <h5>{{area.area_Name}}</h5>
          <div *ngFor="let lineItem of area.quoteAreas">
            <table *ngIf="lineItem.changeOrderItem" class="table" width="100%">
              <thead>
                <tr>
                  <th>Accepted</th>
                  <th>Name</th>
                  <th>R-Value</th>
                  <th>Product</th>
                  <th>Sqr Ftg Adj</th>
                  <th><span class="float-right">Cost Change</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">
                    <mat-radio-group name="changeOrderItem_RadioValue{{lineItem.changeOrderItem.changeOrderItem_ID}}"
                                     [(ngModel)]="lineItem.changeOrderItem.changeOrderItem_RadioValue" #changeOrderItem_RadioValue="ngModel"
                                     (change)="calculateConversion()">
                      <mat-radio-button [value]="1">Accept</mat-radio-button><br />
                      <!--<mat-radio-button [value]="0">Decline</mat-radio-button>-->
                    </mat-radio-group>
                  </td>
                  <td>
                    <span *ngIf="lineItem.changeOrderItem.changeOrderItem_Name">{{lineItem.changeOrderItem.changeOrderItem_Name}}</span>
                    <span *ngIf="!lineItem.changeOrderItem.changeOrderItem_Name">{{lineItem.changeOrderItem.subArea.subArea_Name}}</span>
                  </td>
                  <td>
                    <span *ngIf="lineItem.changeOrderItem.itemUsage; then usageBlock; else rValueBlock"></span>
                    <ng-template #usageBlock>{{lineItem.changeOrderItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                    <ng-template #rValueBlock>
                      <span *ngIf="lineItem.changeOrderItem.item?.rValue">{{lineItem.changeOrderItem.item.rValue.rValue_Desc}}</span>
                    </ng-template>
                  </td>
                  <td>
                    <div *ngIf="lineItem.changeOrderItem.item">
                      <span *ngIf="lineItem.changeOrderItem.item.item_Part">{{lineItem.changeOrderItem.item.item_Part}}, </span>
                      {{lineItem.changeOrderItem.item.item_Name}}
                    </div>
                    <div *ngIf="!lineItem.changeOrderItem.item">
                      {{lineItem.changeOrderItem.changeOrderItem_Note}}
                    </div>
                    <span *ngIf="lineItem.changeOrderItem.changeOrderItem_IsDelete">(DELETED)</span>
                  </td>
                  <td>
                    {{lineItem.changeOrderItem.changeOrderItem_SqrFtgAdjustment}}
                  </td>
                  <td>
                    <span class="float-right">${{lineItem.changeOrderItem.changeOrderItem_TotalCost | number: '1.2-2'}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div *ngFor="let newItem of area.newItems">
            <table class="table" width="100%">
              <thead>
                <tr>
                  <th>
                    <ng-template [ngIf]="!area.area_IsOption">Accepted</ng-template>
                  </th>
                  <th>Name</th>
                  <th>R-Value</th>
                  <th>Product</th>
                  <th>Sqr Ftg Adj</th>
                  <th><span class="float-right">Estimate Change</span></th>
                  <th><span class="float-right">Cost Change</span></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td align="center">
                    <mat-radio-group name="changeOrderItem_RadioValue{{newItem.changeOrderItem_ID}}"
                                     [(ngModel)]="newItem.changeOrderItem_RadioValue" #changeOrderItem_RadioValue="ngModel"
                                     (change)="calculateConversion()">
                      <mat-radio-button [value]="1">Accept</mat-radio-button><br />
                      <!--<mat-radio-button [value]="0">Decline</mat-radio-button>-->
                    </mat-radio-group>
                  </td>
                  <td>
                    <span *ngIf="newItem.changeOrderItem_Name">{{newItem.changeOrderItem_Name}}</span>
                    <span *ngIf="!newItem.changeOrderItem_Name">{{newItem.subArea.subArea_Name}}</span>
                  </td>
                  <td>
                    <span *ngIf="newItem.itemUsage; then usageBlock; else rValueBlock"></span>
                    <ng-template #usageBlock>{{newItem.itemUsage.rValue.rValue_Desc}}</ng-template>
                    <ng-template #rValueBlock>
                      <span *ngIf="newItem.item?.rValue">{{newItem.item.rValue.rValue_Desc}}</span>
                    </ng-template>
                  </td>
                  <td>
                    <div *ngIf="newItem.item">
                      <span *ngIf="newItem.item.item_Part">{{newItem.item.item_Part}}, </span>
                      {{newItem.item.item_Name}} (New Item)
                    </div>
                    <div *ngIf="!newItem.item">
                      {{newItem.changeOrderItem_Note}}
                    </div>
                  </td>
                  <td>
                    {{newItem.changeOrderItem_SqrFtgAdjustment}}
                  </td>
                  <td>
                    <span class="float-right">${{newItem.changeOrderItem_TotalCost | number: '1.2-2'}}</span>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="estimate-pnl">
        <h5 align="center">ESTIMATE</h5>
        <table class="table table-bidit">
          <tbody>
            <tr *ngIf="this.showMargins">
              <td>Total Cost:</td>
              <td>${{changeOrder.totalCost | number: '1.2'}}</td>
            </tr>
            <tr *ngIf="this.showMargins">
              <td>Gross Margin:</td>
              <td>
                <div *ngIf="showMarginEdit; else marginView" class="form-group" id="showMargin">
                  <div class="input-group-prepend">
                    <button class="btn btn-outline-danger form-control" (click)="updateMargin()">
                      Calculate
                    </button>
                  </div>
                  <input name="changeOrder_GrossMargin" type="number" id="changeOrder_GrossMargin" class="form-control"
                         [(ngModel)]="changeOrder.changeOrder_GrossMargin" #changeOrder_GrossMargin="ngModel" />
                </div>
                <ng-template #marginView>
                  <div>
                    <a class="float-left" href="javascript:void(0);" (click)="editMargin()">Edit</a>
                    <span class="float-right">{{changeOrder.changeOrder_GrossMargin | number: '1.0-4'}}%</span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <tr *ngIf="this.showMargins">
              <td>Bid Amount:</td>
              <td>
                <div *ngIf="showBidAmountEdit; else bidAmountView" class="input-group input-group-sm" id="show">
                  <div class="input-group-prepend">
                    <button class="btn btn-outline-danger form-control" name="editAmount" value="editAmount" (click)="updateBid()">
                      Calculate
                    </button>
                  </div>
                  <input name="changeOrder_BidAmount" id="changeOrder_BidAmount" type="text" class="form-control"
                         style="text-align:right;"
                         [(ngModel)]="changeOrder.changeOrder_BidAmount" #changeOrder_BidAmount="ngModel">
                </div>
                <ng-template #bidAmountView>
                  <div>
                    <a href="javascript:void(0);" (click)="editBid()">Edit</a>
                    <span class="float-right">${{changeOrder.changeOrder_BidAmount | number: '1.2-2'}}</span>
                  </div>
                </ng-template>
              </td>
            </tr>
            <tr *ngIf="this.showMargins">
              <td>Margin Dollars:</td>
              <td>${{changeOrder.changeOrder_BidAmount - changeOrder.totalCost | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td>
                <label i18n>Tax Amount:</label>
              </td>
              <td>${{this.netTaxTotal | number: '1.2-2'}}</td>
            </tr>
            <tr>
              <td i18n>Total Bid Amount:</td>
              <td>${{this.changeOrderTotalBidAmount | number: '1.2-2'}}</td>
            </tr>
          </tbody>
        </table>
      </div>

      <div [hidden]="!upgradeForm.submitted || upgradeForm.valid"
           class="alert alert-danger">
        Validation issues encountered.  Please review your entered information.
      </div>
      <div class="row">
        <div class="col-sm-4"></div>
        <div class="col-sm-8">
          <button mat-button type="submit" class="btn btn-bidit-submit mr-1">Submit</button>
          <button mat-button type="button" (click)="onNoClick()" class="btn btn-bidit-cancel">Cancel</button>
        </div>
      </div>
    </form>
  </div>
</div>
